import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3fb7o7n9vq: FaireBrandEntity = {
  token: "b_3fb7o7n9vq",
  type: "brand",
  name: "Wandf",
  avatarUrl:
    "https://cdn.faire.com/fastly/08ec7791eedcc2ae9a6d5c6cf96a0e23c7f53f181e137ba81dccbb2777c7fdc7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ba44a046379834b3e3eb55dea474faf52d5e463ea5aae8cd607ef54ed6b78b53.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/08ec7791eedcc2ae9a6d5c6cf96a0e23c7f53f181e137ba81dccbb2777c7fdc7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ba44a046379834b3e3eb55dea474faf52d5e463ea5aae8cd607ef54ed6b78b53.jpeg",
  location: "Gaithersburg, MD, USA",
  minimumOrderDollars: 206,
  rating: 4.5,
  reviewCount: 41,
  isInsider: true,
  description:
    "Founded in 2014, W&F is a design company based in the Montgomery Maryland. Our goal is to create durable, high-quality bags and accessories that meet the demands of the city. Our collection of modern and functional bags are designed for the everyday professional, commuter and traveler navigating an ever-changing urban environment.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:37.013Z",
    importedBy: "entity-db-cli",
  },
};
